/* ============================================================
   OREN QUIZ — Logique du funnel quiz anti-chute
   ============================================================
   - State stocké dans localStorage
   - Step actuel dans URL hash (#step=N) pour deeplink
   - Branchement Q5 → diagnostic dynamique (5 variantes)
   - Redirection finale vers LP avec params
   ============================================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'orenQuizState';
  const TOTAL_STEPS = 20; // 0 (hook) → 19 (urgence)
  const LP_HANDLE = (function () {
    var el = document.querySelector('[data-oren-quiz]');
    return (el && el.dataset.lpHandle) || 'pepins-de-courge-softgels-cure-personnalisee';
  })();
  const REDIRECT_BASE = (function () {
    var el = document.querySelector('[data-oren-quiz]');
    return (el && el.dataset.redirectBase) || '/products/';
  })();

  const OrenQuiz = {
    state: {
      step: 0,
      answers: {}
    },

    /* ---------- INIT ---------- */
    init() {
      this.root = document.querySelector('[data-oren-quiz]');
      if (!this.root) return;

      this.trackInit();
      this.loadState();
      this.bindEvents();
      this.bindHash();
      this.goToStep(this.state.step);
    },

    /* ---------- ANALYTICS ---------- */
    trackInit() {
      this.trackEndpoint = this.root.dataset.trackEndpoint || '';
      this.quizVariant = this.root.dataset.quizVariant || 'fb';
      // session_id persistant (localStorage)
      try {
        this.sessionId = localStorage.getItem('orenQuizSessionId');
        if (!this.sessionId) {
          this.sessionId = this.uuidv4();
          localStorage.setItem('orenQuizSessionId', this.sessionId);
        }
      } catch (e) { this.sessionId = this.uuidv4(); }
      // Capture UTM from URL (utilise quasi tout le funnel)
      const p = new URLSearchParams(window.location.search);
      this.utm = {
        utm_source: p.get('utm_source') || null,
        utm_medium: p.get('utm_medium') || null,
        utm_campaign: p.get('utm_campaign') || null,
      };
      this.referrer = document.referrer || null;
    },

    uuidv4() {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },

    track(event, payload) {
      if (!this.trackEndpoint || !this.sessionId) return;
      const body = Object.assign({
        session_id: this.sessionId,
        quiz: this.quizVariant,
        event: event,
        referrer: this.referrer,
        utm_source: this.utm.utm_source,
        utm_medium: this.utm.utm_medium,
        utm_campaign: this.utm.utm_campaign,
      }, payload || {});
      // Important : utiliser text/plain (simple CORS content-type) sinon le preflight
      // OPTIONS est requis et sendBeacon ne peut pas le faire → beacon silencieusement droppé.
      // Le serveur parse la string en JSON manuellement.
      try {
        const payload = JSON.stringify(body);
        if (navigator.sendBeacon) {
          const blob = new Blob([payload], { type: 'text/plain' });
          navigator.sendBeacon(this.trackEndpoint, blob);
        } else {
          fetch(this.trackEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: payload,
            keepalive: true,
          }).catch(() => {});
        }
      } catch (e) { /* fail silent */ }
    },

    loadState() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const parsed = JSON.parse(saved);
          this.state = Object.assign(this.state, parsed);
        }
        const hashStep = this.parseHashStep();
        if (hashStep !== null) this.state.step = hashStep;
      } catch (e) {
        console.warn('OrenQuiz: state restore failed', e);
      }
    },

    saveState() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state));
      } catch (e) {}
    },

    parseHashStep() {
      const m = (window.location.hash || '').match(/step=(\d+)/);
      return m ? Math.min(Math.max(parseInt(m[1], 10), 0), TOTAL_STEPS - 1) : null;
    },

    bindHash() {
      window.addEventListener('hashchange', () => {
        const s = this.parseHashStep();
        if (s !== null && s !== this.state.step) this.goToStep(s);
      });
    },

    /* ---------- EVENTS ---------- */
    bindEvents() {
      this.root.addEventListener('click', (e) => {
        const target = e.target.closest('[data-quiz-action]');
        if (!target) return;
        e.preventDefault();
        const action = target.dataset.quizAction;

        if (action === 'next') this.next();
        else if (action === 'prev') this.prev();
        else if (action === 'skip') {
          this.track('skip', { step: this.state.step });
          const skipParams = new URLSearchParams({ utm_source:'quiz', utm_medium:'onsite', utm_campaign:'quiz-skip' });
          window.location.href = `${REDIRECT_BASE}${LP_HANDLE}?${skipParams.toString()}`;
        }
        else if (action === 'answer') this.handleAnswer(target);
        else if (action === 'submit-final') this.submitFinal();
        else if (action === 'restart') { this.track('restart'); this.restart(); }
      });
    },

    handleAnswer(el) {
      const qid = el.dataset.qid;
      const value = el.dataset.value;
      const multi = el.dataset.multi === 'true';
      if (!qid || value === undefined) return;

      if (multi) {
        if (!Array.isArray(this.state.answers[qid])) this.state.answers[qid] = [];
        const idx = this.state.answers[qid].indexOf(value);
        if (idx >= 0) {
          this.state.answers[qid].splice(idx, 1);
          el.classList.remove('is-selected');
        } else {
          this.state.answers[qid].push(value);
          el.classList.add('is-selected');
        }
        this.updateMultiSelectContinueBtn(qid);
        this.saveState();
        this.track('answer', { qid: qid, value: this.state.answers[qid], step: this.state.step });
      } else {
        this.state.answers[qid] = value;
        this.saveState();
        this.track('answer', { qid: qid, value: value, step: this.state.step });
        setTimeout(() => this.next(), 200);
      }
    },

    updateMultiSelectContinueBtn(qid) {
      const stepEl = document.querySelector(`[data-step][data-question="${qid}"]`);
      if (!stepEl) return;
      const btn = stepEl.querySelector('[data-quiz-action="next"]');
      if (!btn) return;
      const ans = this.state.answers[qid];
      const count = Array.isArray(ans) ? ans.length : 0;
      btn.disabled = count === 0;
      btn.classList.toggle('is-disabled', count === 0);
    },

    /* ---------- NAVIGATION ---------- */
    next() {
      let target = this.state.step + 1;
      if (target >= TOTAL_STEPS) target = TOTAL_STEPS - 1;
      this.goToStep(target);
    },

    prev() {
      let target = this.state.step - 1;
      if (target < 0) target = 0;
      this.goToStep(target);
    },

    goToStep(n) {
      this.state.step = n;
      this.saveState();
      this.track('step_view', { step: n });

      // Update URL hash silently
      const newHash = `#step=${n}`;
      if (window.location.hash !== newHash) {
        history.replaceState(null, '', newHash);
      }

      // Hide all, show target
      const allSteps = this.root.querySelectorAll('[data-step]');
      allSteps.forEach((el) => {
        el.classList.toggle('is-active', parseInt(el.dataset.step, 10) === n);
      });

      // Restore multi-select selections on this step
      this.restoreSelections(n);

      // Update progress bar
      this.updateProgress(n);

      // Show/hide back button (hide on hook + loading screens + final urgency)
      this.updateBackBtn(n);

      // Special handling for loadings + diagnostic
      if (n === 14) this.runLoading('loading-1', 16);
      if (n === 15) this.renderDiagnostic();
      if (n === 17) this.runLoading('loading-2', 18);

      // Scroll to top of the quiz
      const top = this.root.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top, behavior: 'smooth' });
    },

    restoreSelections(stepNum) {
      const stepEl = this.root.querySelector(`[data-step="${stepNum}"]`);
      if (!stepEl) return;
      const qid = stepEl.dataset.question;
      if (!qid) return;
      const ans = this.state.answers[qid];

      stepEl.querySelectorAll('[data-quiz-action="answer"]').forEach((b) => {
        b.classList.remove('is-selected');
        if (!ans) return;
        if (Array.isArray(ans) && ans.includes(b.dataset.value)) {
          b.classList.add('is-selected');
        } else if (ans === b.dataset.value) {
          b.classList.add('is-selected');
        }
      });

      this.updateMultiSelectContinueBtn(qid);
    },

    updateBackBtn(n) {
      const btn = this.root.querySelector('[data-quiz-back]');
      if (!btn) return;
      // Masqué sur : 0 (hook), 14 (loading 1), 17 (loading 2)
      const hideOn = [0, 14, 17];
      btn.style.display = hideOn.indexOf(n) !== -1 ? 'none' : '';
    },

    updateProgress(n) {
      const progressEl = this.root.querySelector('[data-quiz-progress]');
      if (!progressEl) return;
      // Show progress only during questions (1-12), hide on hook + transitions
      const showFrom = 1, showTo = 12;
      if (n >= showFrom && n <= showTo) {
        progressEl.style.display = '';
        const pct = ((n - showFrom + 1) / (showTo - showFrom + 1)) * 100;
        const bar = progressEl.querySelector('[data-quiz-progress-bar]');
        if (bar) bar.style.width = pct + '%';
        const label = progressEl.querySelector('[data-quiz-progress-label]');
        if (label) label.textContent = `Question ${n} / ${showTo}`;
      } else {
        progressEl.style.display = 'none';
      }
    },

    /* ---------- LOADINGS ---------- */
    runLoading(id, nextStepAfter) {
      const stepEl = this.root.querySelector(`[data-loading="${id}"]`);
      if (!stepEl) return;
      const counter = stepEl.querySelector('[data-loading-counter]');
      const circle = stepEl.querySelector('[data-loading-circle]');
      const items = stepEl.querySelectorAll('[data-loading-item]');

      let pct = 0;
      const duration = 2800; // ~2.8s
      const start = Date.now();
      const tick = () => {
        const elapsed = Date.now() - start;
        pct = Math.min(100, Math.round((elapsed / duration) * 100));
        if (counter) counter.textContent = pct + '%';
        if (circle) circle.style.setProperty('--quiz-loading-pct', pct);

        // Reveal items progressively
        items.forEach((item, idx) => {
          const threshold = (idx / items.length) * 100;
          if (pct >= threshold) item.classList.add('is-done');
        });

        if (pct < 100) {
          requestAnimationFrame(tick);
        } else {
          setTimeout(() => this.goToStep(nextStepAfter), 350);
        }
      };
      tick();
    },

    /* ---------- DIAGNOSTIC (BRANCHEMENT Q5) ----------
       Générique : la valeur Q5 sert directement de nom de branche,
       à condition de matcher [a-z0-9-]{1,40} (slug safe).
       Permet de partager ce JS entre les quiz Oren (pilule/postpartum/menopause/ozempic/postminoxidil)
       et Maison Lys (menopause/contraception/sedentaire/chaleur/cellulite). */
    getBranch() {
      const a = this.state.answers.q5;
      if (!a || a === 'aucun') return 'general';
      if (typeof a !== 'string' || !/^[a-z0-9-]{1,40}$/.test(a)) return 'general';
      return a;
    },

    renderDiagnostic() {
      const branch = this.getBranch();
      const allVariants = this.root.querySelectorAll('[data-diagnostic-variant]');
      allVariants.forEach((v) => {
        v.classList.toggle('is-active', v.dataset.diagnosticVariant === branch);
      });
    },

    /* ---------- FINAL SUBMIT ---------- */
    submitFinal() {
      const branch = this.getBranch();
      const ageRange = this.state.answers.q0 || '';
      const zone = this.state.answers.q1 || '';
      const sev = this.state.answers.q2 || '';

      this.track('finished', { branch: branch, age: ageRange, zone: zone, severity: sev, step: this.state.step });

      const params = new URLSearchParams({
        utm_source: 'quiz',
        utm_medium: 'onsite',
        utm_campaign: 'quiz-diagnostic',
        branch,
        age: ageRange,
        zone: zone,
        sev: sev
      });

      const url = `${REDIRECT_BASE}${LP_HANDLE}?${params.toString()}`;
      window.location.href = url;
    },

    /* ---------- RESTART ---------- */
    restart() {
      if (!confirm('Recommencer le quiz depuis le début ?')) return;
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      this.state = { step: 0, answers: {} };
      this.goToStep(0);
    }
  };

  /* ---------- BOOT ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => OrenQuiz.init());
  } else {
    OrenQuiz.init();
  }

  // Expose globally for debug
  window.OrenQuiz = OrenQuiz;
})();
